var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemSaveIconFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,4.34V24.86a3.65,3.65,0,0,1-.39,1.65,2.9,2.9,0,0,1-1.12,1.18,2.31,2.31,0,0,1-1.56.27,2.49,2.49,0,0,1-1.38-.79L9.5,21.72l-5,5.45A2.41,2.41,0,0,1,2.67,28h0a2.36,2.36,0,0,1-1.15-.31A2.78,2.78,0,0,1,.39,26.51,3.55,3.55,0,0,1,0,24.86V4.34a4.79,4.79,0,0,1,1-3A3.39,3.39,0,0,1,3.63,0H15.37A3.39,3.39,0,0,1,18,1.32,4.79,4.79,0,0,1,19,4.34Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemSaveIconFill);
export default __webpack_public_path__ + "static/media/item_save_icon_fill.f2641129231527350580ed918c088a76.svg";
export { ForwardRef as ReactComponent };